import { render, staticRenderFns } from "./LoaderFiles.vue?vue&type=template&id=9d706070&scoped=true&lang=pug"
import script from "./LoaderFiles.vue?vue&type=script&lang=js"
export * from "./LoaderFiles.vue?vue&type=script&lang=js"
import style0 from "./LoaderFiles.vue?vue&type=style&index=0&id=9d706070&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d706070",
  null
  
)

export default component.exports